import type { OpportunityDef } from '@/lib/types';

interface OpportunityCardProps {
  def: OpportunityDef;
  count: number;
  active: boolean;
  onSelect: () => void;
  onCampaign: () => void;
}

const dotColor = {
  neutral: 'bg-faint',
  warn: 'bg-warn',
  crit: 'bg-crit',
} as const;

export function OpportunityCard({
  def,
  count,
  active,
  onSelect,
  onCampaign,
}: OpportunityCardProps) {
  const empty = count === 0;
  return (
    <div
      className={`border rounded-lg p-4 px-[18px] pb-3.5 flex flex-col gap-1.5 transition-all ${
        active
          ? 'bg-subtle border-line-strong shadow-pressed'
          : 'bg-glass backdrop-blur-xl backdrop-saturate-150 border-line-glass shadow-card'
      }`}
    >
      <div className="flex items-center gap-2">
        <span className={`w-1.5 h-1.5 rounded-full shrink-0 ${dotColor[def.severity]}`} aria-hidden="true" />
        <div className="text-[13px] font-semibold text-primary tracking-[-0.005em] flex-1">
          {def.title}
        </div>
        <div className="text-[22px] font-semibold tracking-[-0.02em] tnum leading-none text-primary">
          {count}
        </div>
      </div>
      <div className="text-[12.5px] text-tertiary leading-[1.5] flex-1 mt-0.5">
        {def.description}
      </div>
      <div className="flex items-center gap-1.5 mt-2.5 pt-2.5 border-t border-line">
        <button
          type="button"
          onClick={onSelect}
          disabled={empty}
          className="inline-flex items-center gap-1 text-xs font-medium text-secondary bg-transparent border border-line rounded-md px-2.5 py-1.5 cursor-pointer transition-colors hover:bg-soft hover:text-primary hover:border-line-default disabled:opacity-35 disabled:cursor-not-allowed disabled:hover:bg-transparent disabled:hover:text-secondary disabled:hover:border-line"
        >
          Ver pacientes <span aria-hidden="true">→</span>
        </button>
        <button
          type="button"
          onClick={onCampaign}
          disabled={empty}
          className="inline-flex items-center gap-1 text-xs font-medium text-tertiary bg-transparent border-0 rounded-md px-2 py-1.5 cursor-pointer transition-colors hover:text-primary hover:bg-soft disabled:opacity-35 disabled:cursor-not-allowed disabled:hover:bg-transparent disabled:hover:text-tertiary"
        >
          Crear campaña
        </button>
      </div>
    </div>
  );
}
